/** Machine ban reasons returned by POST auth/ban-check, mapped to user-facing copy.
 *  Strings match the Android app verbatim. Any other reason is admin free text. */
const BAN_REASON_COPY: Record<string, string> = {
  parental_consent_revoked: 'This account was closed because a parent withdrew consent.',
  age_ineligible: 'Beat Duel is for ages 13 and up.',
};

export function banReasonCopy(reason: string): string {
  return Object.hasOwn(BAN_REASON_COPY, reason) ? BAN_REASON_COPY[reason] : reason;
}
